import { useEffect, useState } from "react";
import { getTagData } from "api/tags";
import StaticDashboardContainer from "../shared/StaticDashboardContainer";
import Card from "../shared/Card/Card";
import tierFacility from 'assets/tierFacility.png';
import Area from "components/charts/Area/Area";
import areaApiConfig from "config/charts/areaApiConfig";
import { Item } from "types/common";
import Gauge from "components/charts/Gauge/Gauge";
import { SmallLoader } from "components/shared/Loader";

const ExecutiveDashboard = () => {

  const [randomTag, setRandomTag] = useState<Item | null>(null);
  const getSingleTag = async () => {
    const randomTagData = await getTagData([244]);
    setRandomTag(randomTagData.data[0]);
  };

  const tableData = [
    { source: "Elastic", system: "Lorem Ipsum", message: "Lorem Ipsum", date: "Lorem Ipsum" },
    { source: "SCADA", system: "Lorem Ipsum", message: "Lorem Ipsum", date: "Lorem Ipsum" },
    { source: "DCIM", system: "Lorem Ipsum", message: "Lorem Ipsum", date: "Lorem Ipsum" },
  ];

  useEffect(() => {
    getSingleTag();
  }, []);

  return (
    <StaticDashboardContainer heading="Executive Dashboard">
      <div className="w-full h-full flex gap-2">
        <div className="bg-black w-[55%] h-full">
          <div className="w-full h-full flex flex-col bg-dark">
            <div className="flex-1 h-full w-full max-h-full flex flex-col gap-2 min-h-0 overflow-hidden">
              <div className="w-full flex flex-col gap-2 h-full">
                {/* Top Section - 1.65 */}
                <div className="flex flex-col gap-2 flex-[1.65] min-h-0">
                  <div className="flex gap-2 w-full min-h-0 h-full">
                    {/* Left side of top row */}
                    <div className="flex flex-col flex-[1.65] min-h-0">
                      <h2 className="font-semibold text-sm 2xl:text-2xl p-2 bg-darkerBlack w-full rounded-md h-min text-center">Power Supply</h2>
                      <div className="flex flex-1 h-[22vh] xl-2xl:h-[24vh] 2xl:h-[26vh]">
                        {randomTag ? (
                          <Gauge
                            data={{ ...randomTag, name: 'Total Power Used', uom: 'MW' }}
                            gaugeType="bigger"
                          />
                        ) : (
                          <div className="flex w-full h-full items-center justify-center">
                            <SmallLoader />
                          </div>
                        )}
                      </div>

                      <div className="flex gap-2 flex-1">
                        <Card title="ITLU">
                          <div className="p-1.5 h-full w-full flex flex-col justify-between">
                            <div className="text-3xl 2xl:text-3xl text-green">99.3%</div>
                            <p className="text-[10px] 2xl:text-xs font-normal text-center">
                              IT Load Utilization
                            </p>
                          </div>
                        </Card>

                        <Card title="Mechanical Load">
                          <div className="p-1.5 h-full w-full flex flex-col justify-between">
                            <div className="text-3xl 2xl:text-3xl text-green">89.3%</div>
                            <p className="text-[10px] 2xl:text-xs font-normal text-center">
                              Data Centers Infrastructure
                            </p>
                          </div>
                        </Card>

                        <Card title="AI Load">
                          <div className="p-1.5 h-full w-full flex flex-col justify-between">
                            <div className="text-3xl 2xl:text-3xl text-green">96.3%</div>
                            <p className="text-[10px] 2xl:text-xs font-normal text-center">
                              Operational capacity unit
                            </p>
                          </div>
                        </Card>
                      </div>
                    </div>

                    {/* Right side of top row */}
                    <div className="grid grid-cols-3 grid-rows-2 gap-2 flex-[1.35]">
                      <div className="col-span-2">
                        <Card title="PUE" className="h-full">
                          <div className="h-full w-full flex flex-col justify-between">
                            <div className="flex gap-2 flex-1">
                              <div className="w-full flex flex-col items-center justify-center">
                                <p className="text-[10px] 2xl:text-lg">Average</p>
                                <p className="text-2xl 2xl:text-5xl text-green">1.63</p>
                              </div>
                              <div className="w-full flex flex-col items-center justify-center">
                                <p className="text-[10px] 2xl:text-lg">Current</p>
                                <p className="text-2xl 2xl:text-5xl text-yellow">1.72</p>
                              </div>
                            </div>
                            <p className="text-[10px] 2xl:text-lg font-normal text-center">
                              Power Usage Effectiveness
                            </p>
                          </div>
                        </Card>
                      </div>

                      <div className="col-span-1">
                        <Card title="Batterie Backup runtime" className="h-full">
                          <div className="flex flex-col justify-center items-center h-full">
                            <p className="text-lg 2xl:text-3xl text-green">0:05:56</p>
                            <p className="text-sm 2xl:text-lg">H : M : S</p>
                          </div>
                        </Card>
                      </div>

                      <div className="col-span-2 flex gap-2">
                        <Card title="Active clients">
                          <div className="p-2 h-full w-full flex items-center justify-center">
                            <div className="text-3xl 2xl:text-4xl text-green">96%</div>
                          </div>
                        </Card>

                        <Card title="RSU">
                          <div className="p-2 h-full w-full flex flex-col justify-between relative">
                            <div className="text-3xl 2xl:text-4xl text-green flex items-center justify-center h-full">96.3%</div>
                            <p className="text-[10px] 2xl:text-xs font-normal text-center absolute bottom-2 left-0 w-full flex items-center justify-center">
                              Rack space utilization
                            </p>
                          </div>
                        </Card>
                      </div>

                      <div className="col-span-1">
                        <Card title="Projected Time to Full Capacity" className="h-full">
                          <div className="flex flex-col justify-center items-center h-full">
                            <p className="text-lg 2xl:text-3xl text-green">0:05:56</p>
                            <p className="text-sm 2xl:text-lg">H : M : S</p>
                          </div>
                        </Card>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Bottom Section - 1.35 */}
                <div className="bg-black rounded-lg overflow-hidden shadow-md w-full flex flex-col justify-between flex-[1.35] min-h-0">
                  <div className="overflow-y-auto flex-1 min-h-0">
                    <table className="w-full text-left text-sm text-white">
                      <thead className="bg-darkBlack text-gray-200 sticky top-0">
                        <tr className="text-sm 2xl:text-lg">
                          <th className="px-4 py-2 2xl:py-3">Data source</th>
                          <th className="px-4 py-2 2xl:py-3">System</th>
                          <th className="px-4 py-2 2xl:py-3">Alarms Message</th>
                          <th className="px-4 py-2 2xl:py-3">Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tableData.map((row, idx) => (
                          <tr
                            key={idx}
                            className={idx % 2 === 0 ? 'bg-gray-800' : ''}
                          >
                            <td className="px-4 py-2 2xl:py-3">{row.source}</td>
                            <td className="px-4 py-2 2xl:py-3">{row.system}</td>
                            <td className="px-4 py-2 2xl:py-3">{row.message}</td>
                            <td className="px-4 py-2 2xl:py-3">{row.date}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="flex justify-end p-1 2xl:p-3 h-min bg-darkBlack">
                    <button className="px-4 py-1 text-sm rounded-md bg-green text-white hover:bg-green/80 transition">
                      See All
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-black w-[45%] h-full">
          <div className="w-full h-full flex flex-col bg-dark">
            <div className="flex-1 h-full w-full max-h-full flex flex-col gap-2 min-h-0 overflow-hidden">
              <div className="w-full flex flex-col gap-2 h-full">
                <div className="flex flex-col gap-2" style={{ flex: 1.65 }}>
                  {/* First Row */}
                  <div className="flex flex-col flex-1 bg-black gap-2 w-full min-h-0 rounded-lg">
                    <h2 className="font-semibold text-sm 2xl:text-2xl p-2 bg-darkerBlack w-full rounded-md h-min text-center">Availability SLA</h2>
                    <div className="flex gap-2 w-full h-full">
                      <Card title="1 m">
                        <div className="p-2 2xl:p-1 h-full w-full bg-black flex items-center justify-center">
                          <div className="text-3xl 2xl:text-5xl text-green h-[70%] h-max">99.3%</div>
                        </div>
                      </Card>

                      <Card title="3 m">
                        <div className="p-2 2xl:p-1 h-full w-full bg-black flex items-center justify-center">
                          <div className="text-3xl 2xl:text-5xl text-green h-[70%] h-max">99.3%</div>
                        </div>
                      </Card>

                      <Card title="6 m">
                        <div className="p-2 2xl:p-1 h-full w-full bg-black flex items-center justify-center">
                          <div className="text-3xl 2xl:text-5xl text-green h-[70%] h-max">99.3%</div>
                        </div>
                      </Card>

                      <Card title="12 m">
                        <div className="p-2 2xl:p-1 h-full w-full bg-black flex items-center justify-center">
                          <div className="text-3xl 2xl:text-5xl text-green h-[70%] h-max">99.3%</div>
                        </div>
                      </Card>
                    </div>
                  </div>

                  {/* Second Row */}
                  <div className="flex gap-2 w-full max-w-full max-h-full min-h-0 flex-1">
                    {/* Cards shrink equally */}
                    <Card title="Cooling Efficiency" className="flex-1 basis-0">
                      <div className="p-2 flex h-full">
                        <div className="w-full flex-1 flex flex-col justify-between">
                          <p className="text-sm 2xl:text-2xl h-[25%]">CER</p>
                          <p className="text-3xl 2xl:text-4xl h-[50%] text-yellow flex items-center justify-center">78%</p>
                          <p className="text-[10px] 2xl:text-xs font-normal h-[25%] flex justify-center items-center">Cooling Efficiency Ratio</p>
                        </div>
                        <div className="w-full flex-1 flex flex-col justify-between">
                          <p className="text-sm 2xl:text-2xl h-[25%]">CCU</p>
                          <p className="text-3xl 2xl:text-4xl h-[50%] text-green flex items-center justify-center">56%</p>
                          <p className="text-[10px] 2xl:text-xs font-normal h-[25%] flex justify-center items-center">Cooling capacity utilization</p>
                        </div>
                      </div>
                    </Card>

                    <Card title="Environmental parameters" className="flex-1 basis-0">
                      <div className="p-2 flex h-full">
                        <div className="w-full flex-1 flex flex-col justify-between">
                          <p className="text-sm 2xl:text-2xl h-[25%]">Temp</p>
                          <p className="text-3xl 2xl:text-4xl h-[50%] text-yellow flex items-center justify-center">78C</p>
                          <p className="text-[10px] 2xl:text-xs font-normal h-[25%] flex justify-center items-center">Average temperature</p>
                        </div>
                        <div className="w-full flex-1 flex flex-col justify-between">
                          <p className="text-sm 2xl:text-2xl h-[25%]">Humidity</p>
                          <p className="text-3xl 2xl:text-4xl h-[50%] text-green flex items-center justify-center">56%</p>
                          <p className="text-[10px] 2xl:text-xs font-normal h-[25%] flex justify-center items-center">Average humidity</p>
                        </div>
                      </div>
                    </Card>

                    {/* Image grows to max height */}
                    <div className="flex-1 flex items-center justify-center min-h-0 p-2 bg-black rounded-md max-h-[25vh]">
                      <img src={tierFacility} className="h-full w-auto object-contain" />
                    </div>
                  </div>
                </div>

                {randomTag && (
                  <div className="min-h-0 h-full max-h-full flex-1" style={{ flex: 1.35 }}>
                    <Card title="Power Buffer, KW" className="h-full">
                      <Area
                        item={randomTag}
                        type="tag"
                        areaType="regular"
                        renderType="lazyLoading"
                        maintainAspectRatio={false}
                        areaApiConfig={areaApiConfig}
                      />
                    </Card>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
    </StaticDashboardContainer >
  );
};

export default ExecutiveDashboard;